import React from 'react'
import { Modal } from 'react-bootstrap'
import './SelectProviderContactStyle.css'
import { Provider } from '@dataTypes/provider.types'
import { useAppDispatch } from '@store/hooks'
import { PROVIDER_CALL_OPTIONS } from '@constants/Providers'
import { formatPhoneNumber } from '@utils/numberFormatter.util'
import { SET_INPUT_NUMBER } from '@store/reducers/messageCenter.reducer'
import { setActiveSidePanel } from '@store/reducers/uiSlice.reducer'

type SelectProviderContactModalProps = {
  show: boolean
  onHide: () => void
  providerData: Provider
}

const SelectProviderContactModal: React.FC<SelectProviderContactModalProps> = ({
  show,
  onHide,
  providerData,
}) => {
  const dispatch = useAppDispatch()
  const onClick = (contactNumber: string): void => {
    dispatch(SET_INPUT_NUMBER(contactNumber))
    dispatch(setActiveSidePanel('phone'))
    onHide()
  }

  return (
    <Modal
      show={show}
      onHide={onHide}
      className="select-provider-contact-modal"
      backdrop="static"
    >
      <Modal.Header className="bg-custom3" closeButton>
        <Modal.Title>Select a staff contact number</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {PROVIDER_CALL_OPTIONS.map((option) => {
          const value = providerData[option.value as keyof Provider] as string

          if (value) {
            return (
              <button
                type="button"
                key={option.value}
                className="unstyled-button provider-contact-item"
                onClick={() => onClick(value)}
              >
                <span className="spcm-display-number">
                  <span className="spcm-dn-number">
                    {formatPhoneNumber(value)}
                  </span>
                  {option.value === 'cellphone' && (
                    <span className="spcm-dn-preferred">Primary</span>
                  )}
                </span>
                <span className="spcm-label">{option.label}</span>
              </button>
            )
          }
          return null
        })}
      </Modal.Body>
    </Modal>
  )
}

export default SelectProviderContactModal
